module.exports = __webpack_public_path__ + "static/img/compress_file_gray.b8c6fe0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/compress_file_gray.svg
// module id = 9ZWr
// module chunks = 46